import { App as AntdApp, ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { themeConfig } from './theme';
import { EnrollmentFlow } from './portal/EnrollmentFlow';

/**
 * Provider stack for the captive portal: the dark+compact AntD theme + RU locale,
 * AntdApp context (for messages/modals), then the linear enrollment flow. No
 * router — the flow is a self-contained state machine (login → register →
 * confirm), which is the lightest thing that builds and demos.
 */
export function App() {
  return (
    <ConfigProvider theme={themeConfig} locale={ruRU}>
      <AntdApp>
        <EnrollmentFlow />
      </AntdApp>
    </ConfigProvider>
  );
}
